var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
    version: "0.0.0",
    organization: "Tina",
    project: "AnimatorWebsiteIcon3",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
    core: "4.5.0",
    title: "Deco2",
    type: "haiku",
    relpath: "code/deco2/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco2-20cb245cfb651e73": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 10.325,
        "sizeAbsolute.y": 10.512,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:5e308e632567": {
        "sizeAbsolute.y": 7,
        "sizeMode.x": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 7,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": 5.1899999999999995,
        "translation.y": 5.255000000000001,
        "style.zIndex": 4,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        },
        "scale.x": 1
      },
      "haiku:ed812c42eff9": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:84f884d220ec": {
        fill: "#8934FF",
        "translation.x": -46,
        "translation.y": -1
      },
      "haiku:751ee469fd39": {
        x: 46.6514216,
        y: 1.15142164,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 0.28376,
        "translation.y": -2.59139,
        "rotation.z": 0.05236
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco2-20cb245cfb651e73",
      "haiku-title": "Deco2"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "5e308e632567",
          "haiku-title": "deco2",
          "haiku-source":
            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/deco2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "ed812c42eff9",
              "haiku-title": "Page-1",
              id: "fc88fb5fbeef"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "84f884d220ec",
                  "haiku-title": "NPM-icon",
                  id: "9b80fb590d18"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "751ee469fd39",
                      "haiku-title": "deco2",
                      id: "0d6d88e8fc0a"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon3/code/deco2/code.js
// module id = 441
// module chunks = 35783957827783